// frontend/src/components/NotificationContainer.jsx
import React, { useState, useEffect } from 'react';
import { useSocket } from '../contexts/SocketContext';
import NotificationToast from './NotificationToast';

const NotificationContainer = () => {
    const { notifications } = useSocket();
    const [activeToasts, setActiveToasts] = useState([]);

    useEffect(() => {
        // Cuando llega una nueva notificación, agregarla a los toasts activos
        if (notifications.length > 0) {
            const latestNotification = notifications[0];
            if (!activeToasts.find(toast => toast.id === latestNotification.id)) {
                setActiveToasts(prev => [latestNotification, ...prev]);
            }
        }
    }, [notifications]);

    const removeToast = (id) => {
        setActiveToasts(prev => prev.filter(toast => toast.id !== id));
    };

    return (
        <div className="fixed right-4 top-4 z-50 space-y-4 w-full max-w-sm">
            {activeToasts.map((toast, index) => (
                <div
                    key={toast.id}
                    style={{
                        position: 'relative',
                        transform: `translateY(${index * (10)}px)`,
                        zIndex: activeToasts.length - index
                    }}
                >
                    <NotificationToast
                        notification={toast}
                        onClose={removeToast}
                    />
                </div>
            ))}
        </div>
    );
};

export default NotificationContainer;